export default [
  {
    path: '/',
    name: 'Home',
    meta: { layout: 'side-nav' },
    component: r => require(['@/pages/index'], r)
  },
  {
    path: '/servicerequests',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Service Requests',
        meta: { layout: 'side-nav' },
        component: r => require(['@/pages/servicerequests/index'], r)
      }
    ]
  },
  {
    path: '/servicerequests/:status',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Service Requests Status',
        meta: { layout: 'side-nav' },
        component: r => require(['@/pages/servicerequests/index'], r),
        props: (route) => ({ id: route.query.id })
      }
    ]
  },
  {
    path: '/servicerequest/:id',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Service Request',
        meta: { layout: 'side-nav' },
        component: r => require(['@/pages/servicerequests/upsert'], r)
      }
    ]
  },
  {
    path: '/location',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'Location',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/location/index'], r)
        }
      }
    ]
  },
  {
    path: '/user',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'User Profile',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/user/index'], r)
        }
      }
    ]
  },
  {
    path: '/issues',
    component: {
      render: h => h('router-view')
    },
    children: [{
      path: '',
      name: 'Issues',
      meta: {
        layout: 'side-nav'
      },
      component(r) {
        require(['@/pages/issues/index'], r)
      }
    }]
  },
  {
    path: '/simulator',
    component: {
      render: h => h('router-view')
    },
    children: [{
      path: '',
      name: 'Simulator',
      meta: {
        layout: 'side-nav'
      },
      component(r) {
        require(['@/pages/simulator/index'], r)
      }
    }]
  },
  {
    path: '/dashboard',
    component: {
      render: h => h('router-view')
    },
    children: [{
      path: '',
      name: 'Dashboard',
      meta: {
        layout: 'side-nav'
      },
      component(r) {
        require(['@/pages/dashboard/index'], r)
      }
    }]
  },
  {
    path: '/about',
    component: { render: h => h('router-view') },
    children: [
      {
        path: '',
        name: 'About',
        meta: { layout: 'side-nav' },
        component(r) {
          require(['@/pages/about/index'], r)
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    meta: { allowAnonymous: true },
    component: r => require(['@/pages/login/index'], r)
  },
  {
    path: '*',
    name: 'Page not Found',
    component: r => require(['@/pages/errors/error-404'], r)
  }
]



// WEBPACK FOOTER //
// ./src/router/routes.js